/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialogue_List_Export_Tc_MultiplierInputs */

const en_dialogue_list_export_tc_multiplier = /** @type {(inputs: Dialogue_List_Export_Tc_MultiplierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TC Multiplier`)
};

const fr_dialogue_list_export_tc_multiplier = /** @type {(inputs: Dialogue_List_Export_Tc_MultiplierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Multiplicateur TC`)
};

const de_dialogue_list_export_tc_multiplier = /** @type {(inputs: Dialogue_List_Export_Tc_MultiplierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TC-Multiplikator`)
};

const it_dialogue_list_export_tc_multiplier = /** @type {(inputs: Dialogue_List_Export_Tc_MultiplierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moltiplicatore TC`)
};

const ru_dialogue_list_export_tc_multiplier = /** @type {(inputs: Dialogue_List_Export_Tc_MultiplierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Множитель TC`)
};

const es_dialogue_list_export_tc_multiplier = /** @type {(inputs: Dialogue_List_Export_Tc_MultiplierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Multiplicador de TC`)
};

const zh_cn2_dialogue_list_export_tc_multiplier = /** @type {(inputs: Dialogue_List_Export_Tc_MultiplierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TC乘数`)
};

const ja_dialogue_list_export_tc_multiplier = /** @type {(inputs: Dialogue_List_Export_Tc_MultiplierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TC乗数`)
};

const hi_dialogue_list_export_tc_multiplier = /** @type {(inputs: Dialogue_List_Export_Tc_MultiplierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टीसी गुणक`)
};

const pt_pt2_dialogue_list_export_tc_multiplier = /** @type {(inputs: Dialogue_List_Export_Tc_MultiplierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Multiplicador TC`)
};

/**
* | output |
* | --- |
* | "TC Multiplier" |
*
* @param {Dialogue_List_Export_Tc_MultiplierInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const dialogue_list_export_tc_multiplier = /** @type {((inputs?: Dialogue_List_Export_Tc_MultiplierInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialogue_List_Export_Tc_MultiplierInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_dialogue_list_export_tc_multiplier(inputs)
	if (locale === "de") return de_dialogue_list_export_tc_multiplier(inputs)
	if (locale === "it") return it_dialogue_list_export_tc_multiplier(inputs)
	if (locale === "ru") return ru_dialogue_list_export_tc_multiplier(inputs)
	if (locale === "es") return es_dialogue_list_export_tc_multiplier(inputs)
	if (locale === "zh-CN") return zh_cn2_dialogue_list_export_tc_multiplier(inputs)
	if (locale === "ja") return ja_dialogue_list_export_tc_multiplier(inputs)
	if (locale === "hi") return hi_dialogue_list_export_tc_multiplier(inputs)
	if (locale === "pt-PT") return pt_pt2_dialogue_list_export_tc_multiplier(inputs)
	return en_dialogue_list_export_tc_multiplier(inputs)
});